var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "d-flex align-items-center justify-content-end mt-3 mb-4"
  }, [_c('div', {
    staticClass: "d-flex"
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "secondary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_vm._v(" 報名審核 ")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.approved
    }
  }, [_vm._v(" 審核通過 ")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.rejected
    }
  }, [_vm._v(" 審核不通過 ")]), _c('b-dropdown-item', {
    on: {
      "click": _vm.resetToPending
    }
  }, [_vm._v(" 重設為待審核 ")])], 2), _c('div', {
    staticClass: "ml-2 mr-2"
  }, [_c('b-dropdown', {
    attrs: {
      "variant": "secondary"
    }
  }, [_c('template', {
    slot: "button-content"
  }, [_vm._v(" 報到設定 ")]), _vm._l(_vm.checkinStatusOptions, function (item) {
    return _c('b-dropdown-item', {
      key: item.value,
      on: {
        "click": function click($event) {
          return _vm.setCheckinResult(item.value);
        }
      }
    }, [_vm._v(" " + _vm._s(item.text) + " ")]);
  })], 2)], 1), _c('div', {
    staticClass: "d-flex align-items-center border-0"
  }, [_c('b-dropdown', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "inverse-primary"
    },
    scopedSlots: _vm._u([{
      key: "button-content",
      fn: function fn() {
        return [_c('span', {
          staticClass: "mdi mdi-file-excel mr-1"
        }), _vm._v(" 匯出excel ")];
      },
      proxy: true
    }])
  }, [_c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.handleExport(0);
      }
    }
  }, [_vm._v("匯出報名資料")]), _c('b-dropdown-item', {
    on: {
      "click": function click($event) {
        return _vm.handleExport(1);
      }
    }
  }, [_vm._v("匯出報名與填寫資料")])], 1)], 1), _vm.canImportRegistrations ? _c('div', {
    staticClass: "ml-2"
  }, [_c('b-button', {
    staticClass: "flex-shrink-0",
    attrs: {
      "variant": "inverse-primary"
    },
    on: {
      "click": function click($event) {
        _vm.showImportModal = true;
      }
    }
  }, [_c('span', {
    staticClass: "mdi mdi-upload mr-1"
  }), _vm._v(" 匯入報名資料 ")])], 1) : _vm._e()], 1), _c('b-input-group', {
    staticClass: "ml-4",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.statusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("選擇審核狀態")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query.status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "status", $$v);
      },
      expression: "query.status"
    }
  })], 1), _c('b-input-group', {
    staticClass: "ml-4",
    staticStyle: {
      "width": "200px"
    }
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.checkinStatusOptions
    },
    on: {
      "change": _vm.handlePageReset
    },
    scopedSlots: _vm._u([{
      key: "first",
      fn: function fn() {
        return [_c('b-form-select-option', {
          attrs: {
            "value": null
          }
        }, [_vm._v("選擇報到狀態")])];
      },
      proxy: true
    }]),
    model: {
      value: _vm.query.checkin_status,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "checkin_status", $$v);
      },
      expression: "query.checkin_status"
    }
  })], 1), _c('b-button', {
    directives: [{
      name: "b-toggle",
      rawName: "v-b-toggle.collapse-1-inner",
      modifiers: {
        "collapse-1-inner": true
      }
    }],
    staticClass: "flex-shrink-0 ml-0 ml-xl-1",
    attrs: {
      "variant": "link"
    }
  }, [_vm._v(" 進階搜尋"), _c('i', {
    staticClass: "fa fa-chevron-down"
  })])], 1), _c('b-collapse', {
    staticClass: "mt-2",
    attrs: {
      "id": "collapse-1-inner"
    }
  }, [_c('div', {
    staticClass: "border p-2"
  }, [_c('b-form', {}, [_c('div', {
    staticClass: "d-flex flex-column flex-xl-row flex-wrap"
  }, [_c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "填寫內容",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋填寫內容",
      "disabled": _vm.loading
    },
    model: {
      value: _vm.query.res_keyword,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "res_keyword", $$v);
      },
      expression: "query.res_keyword"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('div', {
          staticStyle: {
            "line-height": "1.2"
          }
        }, [_vm._v(" 會員名稱"), _c('br'), _vm._v("(顯示名稱) ")])];
      },
      proxy: true
    }])
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋會員名稱(顯示名稱)",
      "disabled": _vm.loading
    },
    model: {
      value: _vm.query.customer_name,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer_name", $$v);
      },
      expression: "query.customer_name"
    }
  })], 1), _c('b-form-group', {
    staticStyle: {
      "width": "50%"
    },
    attrs: {
      "label": "會員編號",
      "label-cols-sm": "3",
      "label-cols-lg": "2",
      "content-cols-sm": "",
      "content-cols-lg": "7"
    }
  }, [_c('b-form-input', {
    staticClass: "mr-3",
    attrs: {
      "placeholder": "搜尋會員編號",
      "disabled": _vm.loading
    },
    model: {
      value: _vm.query.customer_outer_code,
      callback: function callback($$v) {
        _vm.$set(_vm.query, "customer_outer_code", $$v);
      },
      expression: "query.customer_outer_code"
    }
  })], 1), _vm._l(_vm.dynamicCustomerFields, function (field) {
    return _c('b-form-group', {
      key: field.key,
      staticStyle: {
        "width": "50%"
      },
      attrs: {
        "label": field.label,
        "label-cols-sm": "3",
        "label-cols-lg": "2",
        "content-cols-sm": "",
        "content-cols-lg": "7"
      }
    }, [_c('b-form-input', {
      staticClass: "mr-3",
      attrs: {
        "placeholder": "\u641C\u5C0B".concat(field.label),
        "disabled": _vm.loading
      },
      model: {
        value: _vm.query[field.queryKey],
        callback: function callback($$v) {
          _vm.$set(_vm.query, field.queryKey, $$v);
        },
        expression: "query[field.queryKey]"
      }
    })], 1);
  })], 2), _c('div', {
    staticClass: "flex-column"
  }, [_c('b-button', {
    staticClass: "mb-2 mb-xl-0 mr-2",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.resetSearch
    }
  }, [_c('i', {
    staticClass: "mdi mdi-restart"
  }), _vm._v(" 重置搜尋條件 ")]), _c('b-button', {
    staticClass: "mb-2 mb-xl-0",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handlePageReset
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  }), _vm._v(" 搜尋 ")])], 1)])], 1)]), _c('b-table', {
    attrs: {
      "responsive": "",
      "striped": "",
      "hover": "",
      "items": _vm.results,
      "fields": _vm.fields,
      "busy": _vm.loading
    },
    on: {
      "sort-changed": _vm.handleSort
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "head(checkbox)",
      fn: function fn() {
        return [_c('b-form-checkbox', {
          on: {
            "change": _vm.toggleSelectAll
          },
          model: {
            value: _vm.selectAll,
            callback: function callback($$v) {
              _vm.selectAll = $$v;
            },
            expression: "selectAll"
          }
        })];
      },
      proxy: true
    }, {
      key: "cell(checkbox)",
      fn: function fn(data) {
        return [_c('b-form-checkbox', {
          model: {
            value: data.item.selected,
            callback: function callback($$v) {
              _vm.$set(data.item, "selected", $$v);
            },
            expression: "data.item.selected"
          }
        })];
      }
    }, {
      key: "cell(avatar_url)",
      fn: function fn(data) {
        return [data.item.source === 'liff' ? _c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.customer.id
              }
            }
          }
        }, [_c('b-avatar', {
          attrs: {
            "src": data.item.customer.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })], 1) : _c('b-avatar', {
          attrs: {
            "src": data.item.customer.avatar_url,
            "variant": "secondary",
            "size": "2rem"
          }
        })];
      }
    }, {
      key: "cell(customer_name)",
      fn: function fn(data) {
        return [data.item.source === 'liff' ? _c('router-link', {
          attrs: {
            "to": {
              name: 'CustomerDetailView',
              params: {
                customerID: data.item.customer.id
              }
            }
          }
        }, [_vm._v(" " + _vm._s(data.item.customer.name) + " ")]) : _c('span', [_vm._v(" " + _vm._s(data.item.customer.name) + " ")])];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.created_at)) + " ")];
      }
    }, {
      key: "cell(status)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.statusForDisplay[data.item.status]) + " ")];
      }
    }, {
      key: "cell(status_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.formatDate(data.item.status_at)) + " ")];
      }
    }, {
      key: "cell()",
      fn: function fn(data) {
        return [data.value !== undefined ? _c('TableCell', {
          attrs: {
            "content": data.value,
            "title": _vm.fields.find(function (f) {
              return f.key === data.field.key;
            }).label
          }
        }) : _vm._e()];
      }
    }])
  }), _c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  }), _c('b-modal', {
    attrs: {
      "title": "匯入報名資料",
      "ok-disabled": !_vm.importFile,
      "ok-title": "匯入",
      "cancel-title": "取消"
    },
    on: {
      "ok": _vm.handleImport
    },
    scopedSlots: _vm._u([{
      key: "modal-footer",
      fn: function fn(_ref) {
        var ok = _ref.ok,
          cancel = _ref.cancel;
        return [_c('b-button', {
          attrs: {
            "size": "sm",
            "variant": "outline-primary"
          },
          on: {
            "click": function click($event) {
              _vm.getSampleExcelFile(_vm.deepGet(_vm.getModule('form'), 'module_config.event.event_customer_import_xls', '/excel/event_registration_sample.xlsx'), '/excel/event_registration_sample.xlsx');
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-file-text"
        }), _vm._v("下載範例檔案")]), _c('b-button', {
          attrs: {
            "variant": "secondary"
          },
          on: {
            "click": cancel
          }
        }, [_vm._v("取消")]), _c('b-button', {
          attrs: {
            "variant": "primary",
            "disabled": !_vm.importFile
          },
          on: {
            "click": ok
          }
        }, [_vm._v("匯入")])];
      }
    }]),
    model: {
      value: _vm.showImportModal,
      callback: function callback($$v) {
        _vm.showImportModal = $$v;
      },
      expression: "showImportModal"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "選擇 Excel 檔案"
    }
  }, [_c('b-form-file', {
    attrs: {
      "accept": ".xlsx,.xls,.csv",
      "placeholder": "請選擇檔案...",
      "drop-placeholder": "拖拽檔案到此處"
    },
    model: {
      value: _vm.importFile,
      callback: function callback($$v) {
        _vm.importFile = $$v;
      },
      expression: "importFile"
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }